import { render } from "./GameAccess.vue?vue&type=template&id=3258eab6"
import script from "./GameAccess.vue?vue&type=script&lang=ts"
export * from "./GameAccess.vue?vue&type=script&lang=ts"
script.render = render

export default script